import styled from 'styled-components'

import { NATIVE_BASE_COLORS, FONT_SIZE, COLOR } from '../../themes'

export const StyleRepeatOptionsView = styled.div`
  .radio-layout {
    display: flex;
    flex-direction: 'row';
    align-items: center;
    min-width: 70px;
    margin-right: 42px;

    &:not(first-child) {
      margin-top: 8px;
    }

    input[type='radio'] {
      width: 24px;
      height: 24px;
      accent-color: ${COLOR.BLACK_5};
      cursor: pointer;
      margin: 0;
    }
  }

  .radio-option {
    font-family: NunitoSansRegular;
    font-size: ${FONT_SIZE.XXS};
    color: ${NATIVE_BASE_COLORS.TEXT[800]};
    margin-left: 8px;
    cursor: pointer;
  }
`
